<div class="header">
  <mat-toolbar color="primary" class="header__main_row">
    <div class="header__left">
      <img src="./assets/img/rightbin_logo_text.svg" alt="Rightbin logo" class="header__logo">
    </div>
    <div class="header__right">
      <button mat-button mat-flat-button color="accent" [matMenuTriggerFor]="menu">
        Track
        <mat-menu #menu="matMenu">
          <a routerLink="collect_form" mat-menu-item>Collect Form</a>
          <button mat-menu-item disabled>Report</button>
          <button mat-menu-item (click)="openSupportRequestModal()">Support</button>
          <button mat-menu-item (click)="openUpdateLastCollectModal()" [disabled]="disableUpdateLastCollect()">Update/Delete Last</button>
        </mat-menu>
      </button>

      @if (accountService.currentAccount | async; as account) {
        <button mat-stroked-button mat-button (click)="signOut()">Sign Out</button>
      } @else {
        <a mat-stroked-button routerLink="login">Sign In</a>
      }

    </div>
  </mat-toolbar>

  @if (networkService.isOffline$ | async) {
    <div>
      <div class="header__offline">
        <p>Rightbin has lost its network connection. Any collections you record will be uploaded once the application is back online.</p>
      </div>
    </div>
  }
</div>
